import React, { useState, useEffect } from 'react';
import { Star } from 'react-feather';
import axios from 'axios';
import { BASE_URL } from '../../Config'; // अपना BASE_URL import कर लो

const ReviewForm = () => {
  const [rating, setRating] = useState(0);
  const [reviewText, setReviewText] = useState('');
  const [ratedFor, setRatedFor] = useState('');
  const [feedbackoption, setFeedbackoption] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [submitSuccess, setSubmitSuccess] = useState(false);

  const userdatatoken = localStorage.getItem('userDatatoken');
  const tokendata = userdatatoken ? `Bearer ${userdatatoken.replace(/"/g, '')}` : '';

  // Fetch feedback options
  const fetchFeedbackOptions = async () => {
    try {
      const response = await axios.get(`${BASE_URL}student-feedback-options`, {
        headers: {
          "content-type": "multipart/form-data",
          Accept: "application/json",
          Authorization: tokendata,
        },
      });

      if (response.data && response.data.data) {
        setFeedbackoption(response.data.data);
      } else {
        setFeedbackoption([]);
      }
    } catch (err) {
      setError(err.message || 'Failed to load options');
      setFeedbackoption([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFeedbackOptions();
  }, []);

  // Star rating handler
  const handleStarClick = (index) => {
    setRating(index + 1);
  };

  // Submit feedback
  const ratingfun = async (e) => {
    e.preventDefault();

    if (!rating || !reviewText.trim() || !ratedFor) {
      alert('Please fill all fields: rating, review, and what you liked.');
      return;
    }

    const formData = new FormData();
    formData.append("rating", rating);
    formData.append("feedback", reviewText);
    formData.append("rated_for", ratedFor);

    try {
      const response = await axios.post(`${BASE_URL}addfeedback`, formData, {
        headers: {
          "content-type": "multipart/form-data",
          Accept: "application/json",
          Authorization: tokendata,
        },
      });

      if (response.data.status === true) {
        setSubmitSuccess(true);
        
        setRating(0);
        setReviewText('');
        setRatedFor('');
      } else {
        alert('Failed to submit feedback. Please try again.');
      }
    } catch (error) {
      console.error('Feedback submit error:', error);
      alert('Something went wrong. Please try again later.');
    }
  };

  // Loading state
  if (loading) {
    return (
      <div className="review-table-card" style={styles.card}>
        <div style={{ textAlign: 'center', padding: '40px 0' }}>
          <div className="spinner-border text-primary" role="status" />
          <p style={{ marginTop: '12px', color: '#555' }}>Loading feedback options...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="review-table-card" style={styles.card}>
      {feedbackoption.length > 0 ? (
        <>
          <div style={styles.header}>
            <h3 style={styles.title}>Reviews & Ratings</h3>
          </div>

          {submitSuccess ? (
            <div style={styles.successMessage}>
              <h4>Thank You!</h4>
              <p>Your feedback has been submitted successfully.</p>
              <p>We appreciate your time and suggestions ❤️</p>
            </div>
          ) : (
            <>
              <div style={styles.ratingSection}>
                <p style={styles.rateUs}>Rate Us</p>
                <div style={styles.stars}>
                  {[0, 1, 2, 3, 4].map((index) => (
                    <Star
                      key={index}
                      size={32}
                      fill={index < rating ? '#FF9529' : 'none'}
                      color={index < rating ? '#FF9529' : '#CFCFCF'}
                      style={styles.star}
                      onClick={() => handleStarClick(index)}
                    />
                  ))}
                </div>
              </div>

              <div style={styles.experienceSection}>
                <p style={styles.experienceLabel}>Tell us about your experience</p>
                <textarea
                  placeholder="Write your honest review here..."
                  value={reviewText}
                  onChange={(e) => setReviewText(e.target.value)}
                  style={styles.textarea}
                />
              </div>

              <p style={styles.likedLabel}>What you liked the most</p>
              <div style={styles.checkboxGroup}>
                {feedbackoption.map((option, index) => (
                  <div key={index} style={styles.checkboxItem}>
                    <input
                      type="radio"
                      name="likedMost"
                      id={`option-${index}`}
                      value={option.label}
                      checked={ratedFor === option.label}
                      onChange={(e) => setRatedFor(e.target.value)}
                      style={styles.radioInput}
                    />
                    <label htmlFor={`option-${index}`} style={styles.radioLabel}>
                      {option.label}
                    </label>
                  </div>
                ))}
              </div>

              <button
                style={{
                  ...styles.submitButton,
                  opacity: rating && reviewText.trim() && ratedFor ? 1 : 0.6,
                  cursor: rating && reviewText.trim() && ratedFor ? 'pointer' : 'not-allowed',
                }}
                onClick={ratingfun}
                disabled={!rating || !reviewText.trim() || !ratedFor}
              >
                Submit Review
              </button>
            </>
          )}
        </>
      ) : (
        <div style={styles.emptyState}>
          <h4>No Feedback Options Available</h4>
          <p style={{ color: '#666', marginTop: '12px' }}>
            We're currently not collecting feedback right now.<br />
            Thank you for being part of our community!
          </p>
        </div>
      )}
    </div>
  );
};

// Styles (same as you had, slightly improved)
const styles = {
  card: {
    backgroundColor: '#fff',
    borderRadius: '16px',
    padding: '24px',
    maxWidth: '380px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  },
  header: { marginBottom: '20px' },
  title: { fontSize: '20px', fontWeight: '600', color: '#1a1a1a', margin: 0 },
  ratingSection: { marginBottom: '24px' },
  rateUs: { fontSize: '14px', color: '#555', margin: '0 0 8px 0' },
  stars: { display: 'flex', gap: '8px' },
  star: { cursor: 'pointer' },
  experienceSection: { marginBottom: '20px' },
  experienceLabel: { fontSize: '14px', color: '#555', margin: '0 0 8px 0' },
  textarea: {
    width: '100%',
    height: '100px',
    padding: '12px',
    border: '1px solid #e0e0e0',
    borderRadius: '8px',
    fontSize: '14px',
    resize: 'none',
    outline: 'none',
  },
  likedLabel: {
    fontSize: '1.3rem',
    fontWeight: '600',
    textAlign: 'center',
    margin: '20px 0 12px',
  },
  checkboxGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    marginBottom: '24px',
  },
  checkboxItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
  },
  radioInput: { margin: 0 },
  radioLabel: { fontSize: '14px', color: '#333', cursor: 'pointer' },
  submitButton: {
    width: '100%',
    padding: '14px',
    backgroundColor: '#FF5A5F',
    color: 'white',
    fontSize: '16px',
    fontWeight: '600',
    border: 'none',
    borderRadius: '12px',
    cursor: 'pointer',
    transition: 'background-color 0.2s',
  },
  emptyState: {
    textAlign: 'center',
    padding: '40px 20px',
    color: '#555',
  },
  successMessage: {
    textAlign: 'center',
    padding: '40px 20px',
    color: '#2e7d32',
  },
};

export default ReviewForm;